/** True when status is Rejected (case-insensitive, trimmed). Used to clear ETA in UI and payloads. */
export function isRejectedTransactionStatus(status: unknown): boolean {
  if (status === null || status === undefined) return false;
  const s = String(status).trim().toLowerCase();
  return s === 'rejected';
}

/** True for terminal "complete" statuses (case-insensitive). Used for ETA handling and completion timestamps. */
export function isCompleteTransactionStatus(status: unknown): boolean {
  if (status === null || status === undefined) return false;
  const s = String(status).trim().toLowerCase();
  return s === 'complete' || s === 'completed';
}
